/** Unidades de medida para catálogo de proveedores (precio/cantidad de referencia). */
export const MEASUREMENT_UNITS = [
    {value: 'pieza', label: 'Pieza'},
    {value: 'unidad', label: 'Unidad'},
    {value: 'caja', label: 'Caja'},
    {value: 'paquete', label: 'Paquete'},
    {value: 'frasco', label: 'Frasco'},
    {value: 'ampolleta', label: 'Ampolleta'},
    {value: 'sobre', label: 'Sobre'},
    {value: 'rollo', label: 'Rollo'},
    {value: 'par', label: 'Par'},
    {value: 'ml', label: 'Mililitro (ml)'},
    {value: 'l', label: 'Litro (L)'},
    {value: 'g', label: 'Gramo (g)'},
    {value: 'kg', label: 'Kilogramo (kg)'},
    {value: 'm', label: 'Metro (m)'}
];

export const DEFAULT_MEASUREMENT_UNIT = 'pieza';

const UNIT_VALUES = new Set(MEASUREMENT_UNITS.map(unit => unit.value));

export const isValidMeasurementUnit = value => UNIT_VALUES.has(String(value || '').trim());

export const getMeasurementUnitLabel = value => {
    const key = String(value || '').trim();
    const found = MEASUREMENT_UNITS.find(unit => unit.value === key);
    return found?.label || key || '—';
};

export const normalizeMeasurementUnit = (value, fallback = DEFAULT_MEASUREMENT_UNIT) => {
    const key = String(value || '').trim();
    return isValidMeasurementUnit(key) ? key : fallback;
};
